import { call, put, takeLatest } from "redux-saga/effects";
import { danhMucApi } from "../../../api/category/danhMucApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eLopActionTypeIds, ILopActions } from "../../action-types/category/ILopActionType";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.category.lop;

export function* lopSaga(): any {
    yield takeLatest(eLopActionTypeIds.LOAD_START, loadWorker);
}


function* loadWorker(action: ILopActions): any {
    const res: IBaseRespone = yield call(danhMucApi.SelectAllLop)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}